import styled, { css } from "styled-components";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
export const StyledMenu = styled(Menu) `
    & .MuiPaper-root li {
        font-size: ${fontSizes.SMALL};

        & svg {
            color: ${colors.navy_main};
        }

        &:hover {
            background-color: ${colors.navy_12};
        }
    }
`;
export const HXMenuTitle = styled(MenuItem) `
    color: ${colors.black_lighter};
    font-size: ${fontSizes.SMALL};
    cursor: default;
    pointer-events: none;
    opacity: 0.7;
`;
export const HXMenuFooter = styled(MenuItem) `
    ${css `
        border-top: 1px solid ${colors.black_12};
        padding: 8px 16px;
    `}
`;
